import { Selected } from "../dynamic/DrawSheets/src/types";
import queryString from "query-string";

const drawsEndPoint = "/tennis/api/TournamentApi/GetDrawsheet";
const filtersEndPoint = "/tennis/api/TournamentApi/GetEventFilters";
const tieMatchesEndPoint = "/tennis/api/TournamentApi/GetTieMatches";
const mastersFiltersEndPoint =
  "/tennis/api/TournamentApi/GetMastersChampionshipEventFilters";

export async function getDraws(
  params: Selected,
  tournamentId: number,
  tourType: string = "N"
) {
  const body = Object.assign({ tournamentId, tourType, weekNumber: 0 }, params);

  const response = await fetch(
    `${process.env.HOST}${drawsEndPoint}?${queryString.stringify(body)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }
  );
  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}

export async function getMastersFilters({
  year,
  tourType
}: {
  year: number;
  tourType: "T" | "N";
}) {
  const response = await fetch(
    `${process.env.HOST}${mastersFiltersEndPoint}?${queryString.stringify({
      year,
      tourType
    })}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }
  );

  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}

export async function getFilters(tournamentKey: string) {
  const response = await fetch(
    `${process.env.HOST}${filtersEndPoint}?tournamentKey=${tournamentKey}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }
  );

  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}

export async function getTieMatches(tieId: number, side1CountryCode: string) {
  const response = await fetch(
    `${process.env.HOST}${tieMatchesEndPoint}?${queryString.stringify({
      tieId,
      side1CountryCode
    })}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }
  );

  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}

export async function getKOTeamMatches(
  tieId: number,
  side1CountryCode: string
) {
  const response = await fetch(
    `${process.env.HOST}${tieMatchesEndPoint}?${queryString.stringify({
      tieId,
      side1CountryCode
    })}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }
  );

  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}
